<div class="container-fluid bg-white py-2">
  <div class="row">
    <div class="col-6 d-flex align-items-center">

      <button
        type="button"
        class="btn d-md-none d-inline-flex align-items-center justify-content-center"
        style="min-width: 44px; min-height: 44px"
        aria-label="Abrir menú"
        [attr.aria-expanded]="sideMenuService.showed"
        (click)="sideMenuService.showed = !sideMenuService.showed">
        <i class="material-icons" aria-hidden="true">menu</i>
      </button>

      @if(title) {
        <div class="ps-2 ps-md-0">
          <b>{{ title }}</b>
        </div>
      }

    </div>

    <div class="col-6 text-end">

      <!-- ════════════════ NOTIFICATION DROPDOWN ════════════════ -->
      <div ngbDropdown
           placement="bottom-end"
           [autoClose]="'outside'"
           #notifDropdown="ngbDropdown"
           class="d-inline-block">

        <!-- TRIGGER: campana con badge -->
        <button
          ngbDropdownToggle
          class="btn p-0 position-relative notif-bell-btn"
          [class.notif-bell-active]="notifDropdown.isOpen()"
          title="Notificaciones"
          style="background: none; border: none; outline: none; width: 36px; height: 36px;
                 display: inline-flex; align-items: center; justify-content: center;
                 border-radius: 50%; transition: background 0.15s ease">
          <i class="material-icons" style="font-size: 22px; color: #64748b; vertical-align: middle">
            notifications
          </i>
          @if (notificationService.unseenCount > 0) {
            <span
              class="position-absolute badge rounded-pill bg-danger"
              style="font-size: 9px; min-width: 16px; height: 16px; padding: 0 4px;
                     top: 0; right: 0; display: flex; align-items: center; justify-content: center;
                     font-weight: 700; border: 2px solid white; pointer-events: none">
              {{ notificationService.unseenCount > 99 ? '99+' : notificationService.unseenCount }}
            </span>
          }
        </button>

        <!-- PANEL FLOTANTE -->
        <div ngbDropdownMenu class="notifications-dropdown-menu p-0">

          <!-- HEADER del panel -->
          <div class="notif-panel-header">
            <span class="notif-panel-title">Notificaciones</span>
            @if (notificationService.unseenCount > 0) {
              <span class="notif-unseen-badge">{{ notificationService.unseenCount }} nuevas</span>
            }
          </div>

          <!-- LISTA de notificaciones -->
          <div class="notif-panel-list">

            @if (notificationService.notifications.length === 0) {
              <!-- EMPTY STATE -->
              <div class="notif-empty-state">
                <div class="notif-empty-icon">
                  <i class="material-icons">notifications_none</i>
                </div>
                <p class="notif-empty-title">Sin notificaciones</p>
                <p class="notif-empty-sub">Estás al día por ahora</p>
              </div>
            }

            @for (notification of notificationService.notifications; track notification.notificationId; let i = $index) {
              @if (i < 8) {
                <div
                  class="notif-item"
                  [class.notif-item-unread]="!notification.seen"
                  [class.notif-item-tappable]="notificationService.canTapNotification(notification)"
                  (click)="onNotificationTap(notification, notifDropdown)">

                  <!-- ÍCONO del tipo -->
                  <div class="notif-icon-circle"
                       [class.notif-icon-chat]="notification.notificationType?.code === 'chat'"
                       [class.notif-icon-default]="notification.notificationType?.code !== 'chat'">
                    @if (notification.notificationType?.image?.urlFile) {
                      <img [src]="notification.notificationType!.image!.urlFile"
                           alt="" style="width: 100%; height: 100%; object-fit: cover; border-radius: 50%">
                    } @else if (notification.notificationType?.code === 'chat') {
                      <i class="material-icons" style="font-size: 20px; color: white">chat</i>
                    } @else {
                      <i class="material-icons" style="font-size: 20px; color: white">notifications</i>
                    }
                  </div>

                  <!-- CONTENIDO -->
                  <div class="notif-content">
                    <p class="notif-title" [class.notif-title-unread]="!notification.seen">
                      {{ notification.title }}
                    </p>
                    <p class="notif-subtitle">{{ notification.subtitle }}</p>
                    <span class="notif-time" [class.notif-time-unread]="!notification.seen">
                      {{ getRelativeTime(notification.createdAt) }}
                    </span>
                  </div>

                  <!-- INDICADORES DERECHOS -->
                  <div class="notif-trailing">
                    @if (notificationService.canTapNotification(notification)) {
                      <i class="material-icons notif-arrow">arrow_forward_ios</i>
                    }
                    @if (!notification.seen) {
                      <div class="notif-dot"></div>
                    }
                  </div>

                </div>
              }
            }

          </div>

          <!-- FOOTER: Ver todas -->
          <div class="notif-panel-footer" (click)="viewAllNotifications(notifDropdown)">
            <i class="material-icons" style="font-size: 16px; margin-right: 6px">notifications_active</i>
            Ver todas las notificaciones
          </div>

        </div>
      </div>
      <!-- ═══════════════════════════════════════════════════════ -->

      @if (notificationPermission !== 'granted') {
        <button
          class="btn p-1 me-1"
          (click)="enableNotifications()"
          [title]="notificationPermission === 'denied' ? 'Notificaciones bloqueadas — actívalas desde el navegador' : 'Activar notificaciones push'"
          style="vertical-align: middle">
          <i class="material-icons"
             [style.color]="notificationPermission === 'denied' ? '#ef4444' : '#f59e0b'"
             style="font-size: 22px; vertical-align: middle">
            {{ notificationPermission === 'denied' ? 'notifications_off' : 'notifications_none' }}
          </i>
        </button>
      }

      <div ngbDropdown class="d-inline-block">
        <button type="button" class="btn" id="dropdownBasic1" ngbDropdownToggle>
          {{ authService.currentUser?.fullName }}
        </button>
        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
          <!-- @if(empresaService.empresas.length > 1) {
            <a 
              ngbDropdownItem 
              class="d-flex align-items-center"
              [routerLink]="['/admin']">
              <i class="material-icons me-1">business</i>
              Empresas
            </a>
            <div class="dropdown-divider"></div>
          } -->
          <button 
            ngbDropdownItem 
            class="d-flex align-items-center text-danger"
            (click)="authService.signOut()">
            <i class="material-icons me-1">logout</i>
            Cerrar sesión
          </button>
        </div>
      </div>

    </div>
  </div>
</div>